import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import areaMap from '../assets/areaMap.json';
import nameMap from '../../../data/worldMap/worldMap.json';

class Map extends PureComponent {
    static propTypes = {
        mapType: PropTypes.string,
        data: PropTypes.object,
        areaName: PropTypes.string,
        nanhai: PropTypes.string,
        devicetype: PropTypes.string,
    };

    state = {
        type: 1,
    };

    map = null;

    async componentDidMount() {
        // 引入 ECharts 主模块
        const echarts = await import('echarts/lib/echarts');

        // 引入地图
        await import('echarts/map/js/china');
        await import('echarts/map/js/world');

        // 引入提示框和标题组件
        await import('echarts/lib/component/tooltip');
        await import('echarts/lib/component/legend');
        await import('echarts/lib/component/legendScroll');

        const { type } = this.state;
        const { mapType } = this.props;

        if (mapType === 'china') {
            this.map = echarts.init(document.getElementById('china'));

            const chinaMap = await import('./china');

            echarts.registerMap('china', chinaMap);
        } else {
            this.map = echarts.init(document.getElementById('world'));

            const worldMap = await import('../../../data/worldall/layout/map/world');

            echarts.registerMap('world', worldMap);
        }

        this.mapRender(type);
    }

    componentDidUpdate(prevProps) {
        const { type } = this.state;

        if (this.props.areaName !== prevProps.areaName) {
            this.mapRender(type);
        }
    }

    mapRender = type => {
        const {
            mapType,
            data: { all, list, gat, extra },
            areaName,
            devicetype,
        } = this.props;

        let mapData = [];

        if (mapType === 'china') {
            mapData = [...list, ...gat].map(item => {
                let num = 0;

                const quezhen = item.quezhen || 0;
                const zhiyu = item.zhiyu || 0;
                const siwang = item.siwang || 0;

                if (item.quezhen_xianyou) {
                    num = item.quezhen_xianyou;
                } else {
                    num = quezhen - zhiyu - siwang;
                }

                return {
                    name: item.name1 === '港澳台' ? item.name2 : item.name1,
                    selected: item.name1 === areaName,
                    itemStyle: {
                        normal: {
                            areaColor: this.getColor(type === 0 ? quezhen : num),
                        },
                    },
                    label: {
                        color: '#000',
                    },
                    num: [num, quezhen, zhiyu, siwang],
                };
            });
        }

        if (mapType === 'world') {
            const yd = [...all, ...extra].map(item => ({
                name: item.name1 === '全国' ? '中国' : item.name2,
                quezhen: item.quezhen,
            }));

            const arr = yd.map(item => item.name);

            Object.keys(nameMap).forEach(item => {
                if (arr.indexOf(nameMap[item]) > -1) {
                    yd.push({
                        name: nameMap[item],
                        quezhen: 0,
                    });
                }
            });

            mapData = yd.map(item => ({
                name: item.name,
                itemStyle: {
                    normal: {
                        areaColor: this.getWorldColor(item.quezhen),
                        // borderColor: item.name === '中国' ? '#CE8A86' : '#ffffff', // 边框颜色
                        borderColor: item.name === '中国' ? '#9E0707' : '#ffffff', // 边框颜色
                        // borderColor: item.name === '中国' ? '#600A0A' : '#ffffff', // 边框颜色
                        borderWidth: item.name === '中国' ? 1.5 : 0.5, // 边框线宽
                    },
                },
            }));
        }

        const chinaSeries = [
            {
                name: '中国',
                type: 'map',
                mapType: 'china',
                left: 0,
                right: 0,
                top: 0,
                itemStyle: {
                    normal: {
                        borderColor: '#E2B2B2', // 边框颜色
                        borderWidth: 0.5, // 边框线宽
                    },
                    emphasis: {
                        areaColor: '#DFEBF6',
                    },
                },
                label: {
                    show: true,
                    textStyle: {
                        // 标签的文本样式
                        fontSize: devicetype === 'pc' ? 18 : 10,
                        color: '#1F1F1F',
                    },
                },
                data: mapData,
            },
        ];

        const worldSeries = [
            {
                name: '世界',
                type: 'map',
                mapType: 'world',
                silent: true,
                left: 0,
                right: 0,
                top: 20,
                itemStyle: {
                    normal: {
                        borderColor: '#ffffff', // 边框颜色
                        borderWidth: 0.5, // 边框线宽
                    },
                },
                label: {
                    show: false,
                },
                data: mapData,
                nameMap,
            },
        ];

        const option = {
            tooltip:
                mapType === 'world'
                    ? {
                          show: false,
                      }
                    : {
                          trigger: 'item',
                          showDelay: 0,
                          enterable: true,
                          transitionDuration: 0.2,
                          padding: 7,
                          borderWidth: 1,
                          extraCssText: 'background:rgba(0,0,0,0.6);box-shadow: 0px 0px 4px 0px rgba(219,219,219,0.5);',
                          textStyle: {
                              color: '#FFFFFF',
                              fontFamily: 'PingFang-SC-Medium,PingFang-SC;',
                              fontSize: 12,
                              padding: 5,
                          },
                          formatter: params => {
                              let result = `<div>${params.name}</div>`;

                              params.data.num.forEach((item, index) => {
                                  let color = '';
                                  let text = '';

                                  if (index === 0) {
                                      color = '#455fce';
                                      text = '现存确诊';
                                  } else if (index === 1) {
                                      color = '#e10000';
                                      text = '累计确诊';
                                  } else if (index === 2) {
                                      color = '#28B7A3';
                                      text = '累计治愈';
                                  } else if (index === 3) {
                                      color = '#8C8C8C';
                                      text = '累计死亡';
                                  }

                                  if ((index !== 0 && type !== 1) || (index !== 1 && type !== 0)) {
                                      result += `<div style="margin-top: 1px"><span style="display:inline-block;margin: 0 5px 3px 0;border-radius:50%;width:5px;height:5px;font-family: PingFangSC-Regular, PingFang SC;background-color:${color}"></span>${text}: ${item ||
                                          0}</div>`;
                                  }
                              });

                            //   if (
                            //       false && params.name !== '西藏' &&
                            //       params.name !== '香港' &&
                            //       params.name !== '澳门' &&
                            //       params.name !== '台湾'
                            //   ) {
                            //       result += `<div style="margin-top: 1px"><a style="color: #ffffff" href=${this.getInfoUrl(
                            //           params.name,
                            //       )}>进入详情 >></a></div>`;
                            //   }

                              return result;
                          },
                      },
            series: mapType === 'world' ? worldSeries : chinaSeries,
        };

        this.map.setOption(option);

        if (mapType === 'china') {
            let i = 0;

            mapData.every((item, index) => {
                if (item.name === areaName) {
                    i = index;

                    return false;
                }

                return true;
            });

            this.map.dispatchAction({
                type: 'showTip',
                seriesIndex: 0,
                dataIndex: i,
            });
        }
    };

    getInfoUrl = areaName => {
        const { devicetype } = this.props;

        let url = '';
        let code = '';

        Object.keys(areaMap).every(item => {
            if (areaName === areaMap[item]) {
                code = item;

                return false;
            }

            return true;
        });

        if (devicetype === 'share') {
            url = `https://ishare.ifeng.com/c/s/7uGaH6JaA1A?prov=${code}&needpage=1&webkit=1`;
        } else if (devicetype === 'client') {
            url = `https://news.ifeng.com/c/specialClient/7uGaH6JaA1A?prov=${code}&needpage=1&webkit=1`;
        } else {
            url = `https://news.ifeng.com/c/special/7uGaH6JaA1A?prov=${code}&needpage=1&webkit=1`;
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = `https://news.ifeng.com/c/vivo/7uGaH6JaA1A?prov=${code}`;
        }

        return url;
    };

    getColor = num => {
        let color = '#F2DADB';

        if (num > 9999999) {
            color = '#600A0A';
        } else if (num > 4999999) {
            color = '#9E0707';
        } else if (num > 999999) {
            color = '#BF5A53';
        } else if (num > 9999) {
            color = '#CE8A86';
        } else if (num === 0) {
            color = '#ffffff';
        }

        return color;
    };

    getWorldColor = num => {
        let color = '#F2DADB';

        if (num > 9999999) {
            color = '#420C0C';
        } else if (num > 4999999) {
            color = '#6C0000';
        } else if (num > 999999) {
            color = '#9E0707';
        } else if (num > 499999) {
            color = '#BF5A53';
        } else if (num > 9999) {
            color = '#CE8A86';
        } else if (num === 0) {
            color = '#ffffff';
        }

        return color;
    };

    handleTypeChange = type => {
        this.setState(
            {
                type,
            },
            () => {
                this.mapRender(type);
            },
        );
    };

    render() {
        const { type } = this.state;
        const { mapType, nanhai } = this.props;

        return (
            <Fragment>
                <div className={styles.box}>
                    <div id={mapType} className={mapType === 'world' ? styles.world_map : styles.china_map} />
                    <span className={mapType === 'world' ? styles.world_tip : styles.tip} />
                    {mapType === 'china' && <img className={styles.nanhai} src={nanhai} />}
                </div>
                {mapType === 'china' && (
                    <div className={styles.btn_box}>
                        <div
                            className={type === 1 ? styles.current_item : styles.item}
                            onClick={() => this.handleTypeChange(1)}>
                            <span>现存确诊</span>
                        </div>
                        <div
                            className={type === 0 ? styles.current_item : styles.item}
                            onClick={() => this.handleTypeChange(0)}>
                            <span>累计确诊</span>
                        </div>
                    </div>
                )}
            </Fragment>
        );
    }
}

export default errorBoundary(Map);
